module.exports = __webpack_public_path__ + "static/media/youtube_icon.36a40b59.svg";